// 床技の予告音 (2026-11-03・駅7の便 #3・洗い出し = docs/research/2026-11-03-floor-tell-sfx-audit.md・記録 = docs/research/2026-11-03-floor-tell-sfx-a.md)。
//   共通の機械音 (telegraph_whirr) に落ちていた床技4つに、そのボスの音と並ぶ低い予告を作った比較版。
//   作者 09-01「高い音に聞こえてこの技のイメージには合わない」。
//   既定 a = 配布版 (11-03 作者が4技とも新しい音に決定)。開発版 ?floorTell=old で前の音 (共通の whirr)。URL は game.ts の DEV の箱の中でだけ読む。
//   素材 = scripts/render_floor_tell_sfx.py → public/sfx/floor_tell_a_<技>.wav (preloadSfxSamples が読む)。
import type { SfxId } from './types'

export const FLOOR_TELL_ATTACKS = ['lanceButt', 'thornAisle', 'lightsFall', 'curtainSweep'] as const
export type FloorTellAttack = typeof FLOOR_TELL_ATTACKS[number]
export type FloorTellSound = 'now' | 'a'
export const FLOOR_TELL_SFX_IDS = FLOOR_TELL_ATTACKS.map(a => `floor_tell_a_${a}` as const)

let floorTell: FloorTellSound = 'a'
export function getFloorTellSound(): FloorTellSound { return floorTell }
export function setFloorTellSound(value: string | null | undefined): FloorTellSound {
  floorTell = value === 'old' ? 'now' : 'a'
  return floorTell
}

/** 溜めに入った時の音。null = 共通の whirr (old・対象外の技)。 */
export function floorTellSfx(attackId: string): SfxId | null {
  if (floorTell === 'now' || !(FLOOR_TELL_ATTACKS as readonly string[]).includes(attackId)) return null
  return `floor_tell_a_${attackId as FloorTellAttack}`
}

/** 先読みする素材 [キー, URL]。 */
export function floorTellFiles(): [string, string][] {
  return FLOOR_TELL_SFX_IDS.map(id => [id, `/sfx/${id}.wav?v=1`])
}
